import dayjs from 'dayjs'
const MIN_RELOAD_TIME = 1000 * 60 * 60 * 6 // 6 hours

/**
 * Track the page view
 *
 * @param {object} context
 */
export default function (context) {
    const revision = context.store.state.app.revision
    const newRevision = localStorage?.getItem('oc-revision')
    const lastReload = localStorage?.getItem('oc-reloaded-at')

    if (!revision || !newRevision || revision === newRevision) {
        return
    }

    let shouldBeReloaded = true

    if (lastReload) {
        const lastReloadDate = dayjs(lastReload)
        const now = dayjs()

        if (now.diff(lastReloadDate) < MIN_RELOAD_TIME) {
            shouldBeReloaded = false
        }
    }

    if (shouldBeReloaded) {
        localStorage.setItem('oc-reloaded-at', new Date())
        window.location.reload()
    }
}
